<template>
  <v-app-bar height="60" class="header" color="grey darken-4" v-if="!this.$route.fullPath.startsWith('/admin')">
    <h3>
      <router-link to="/" class="logo base pink--text font-weight-bold">{{ $TITLE }}</router-link>
    </h3>
    <v-spacer></v-spacer>
    <v-btn icon class="mx-1 base" to="/shoppingcart">
      <v-badge offset-x="10" offset-y="10" color="pink" :content="totalNum.toString()">
        <v-icon>fa-shopping-cart</v-icon>
      </v-badge>
    </v-btn>
    <template v-if="!isLogin">
      <router-link to="/login" class="d-flex">
        <v-icon left small color="white">fa-user</v-icon>
        登入
      </router-link>
    </template>
    <template v-else>
      <div class="tablet-only desktop-only hidden">
        <a class="base d-flex align-center" @click="$root.$emit('peachList')">
          <div class="peach"></div>
          <span class="pink--text">{{ user.peach }}</span>
        </a>
      </div>
      <router-link to="/profile">
        {{ user.nickname }}
      </router-link>
    </template>
 <!--    <div class="tablet-only mobile-only hidden">
      <v-btn icon @click="$refs.fullScreenMenu.dialog = true">
        <v-icon>fa-bars</v-icon>
      </v-btn>
    </div>
    <FullScreenHeader ref="fullScreenMenu"></FullScreenHeader> -->
  </v-app-bar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FullScreenHeader from '@/components/FullScreenHeader'
export default {
  components: { FullScreenHeader },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isLogin']),
    ...mapGetters('shoppingCart', ['totalNum']),
  },
}
</script>

<style lang="scss" scoped>
.header {
  padding: 0 50px;
  @include mobile {
    padding: 0;
  }
  @include tablet {
    padding: 0;
  }
  a {
    margin: 0 12px;
    position: relative;
    text-decoration: none;
    color: white !important;
    &:not(.base):hover {
      color: $main !important;
      i {
        color: $main !important;
      }
      &::after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: $main;
        position: absolute;
        left: 0;
        bottom: -5px;
      }
    }
  }
  .v-icon {
    transition: none !important;
    color: white !important;
  }
}
</style>